// Note:  Canister IDs are not constant, so are not provided here.
//        The same applies to HOST.
export const E8S_PER_TOKEN = BigInt(100000000);
